import React from 'react';
import TimerIcon from '@mui/icons-material/Timer';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import {Certification, CertificationPhase, CertificationStatus} from '../../../../store/projects/commonTypes';
import PhaseStepper from "../../../stepper/Stepper";
import {certificationStatusOptions, getOptionLabel} from "../../../../utils/utils";

export interface AssessmentStepperProps {
    certification: Certification;
}

const icons = [
    <TimerIcon />,
    <AutorenewIcon />,
    <CheckCircleOutlineIcon />,
];

const getActiveStep = (certification: Certification): number => {
    return certification.certificationPhase
};

const AssessmentStepper: React.FC<AssessmentStepperProps> = ({ certification }) => {
    const activeStep = getActiveStep(certification);

    return (
        <div className="row d-flex justify-content-center mt-4 mb-4">
            <PhaseStepper 
                steps={[
                    getOptionLabel(certificationStatusOptions, CertificationPhase.received),
                    getOptionLabel(certificationStatusOptions, CertificationPhase.inProgress),
                    getOptionLabel(certificationStatusOptions, CertificationPhase.completed)
                ]} 
                activeStep={activeStep} 
                icons={icons} />
        </div>
    );
};

export default AssessmentStepper;